// Shared helpers for order candidates (driver assignment offers).

const STATUS_MAP = {
  pending: { text: "بانتظار الرد", class: "badge-light-warning" },
  driver_accept: { text: "قبل الطلب", class: "badge-light-success" },
  driver_rejected: { text: "رفض الطلب", class: "badge-light-danger" },
  expired: { text: "انتهت المهلة", class: "badge-light-secondary" },
  order_taken_from_another_driver: {
    text: "أُخذ من سائق آخر",
    class: "badge-light-info",
  },
};

const SOURCE_MAP = {
  admin_assignment: "تعيين من لوحة التحكم",
  auto_assignment: "نظام الإسناد",
  system: "نظام الإسناد",
};

export const candidateStatusItems = Object.keys(STATUS_MAP).map((value) => ({
  value,
  text: STATUS_MAP[value].text,
}));

export function candidateStatusMeta(status) {
  return (
    STATUS_MAP[status] || {
      text: status || "-",
      class: "badge-light-info",
    }
  );
}

export function candidateSourceText(source) {
  if (!source) return "-";
  return SOURCE_MAP[source] || source;
}

// Candidate dates arrive from the dashboard API already in the order country's
// timezone, so they must be displayed as-is (no Date parsing / tz conversion).
export function formatCandidateDate(value) {
  if (!value) return "-";
  const m = String(value).match(
    /^(\d{4}-\d{2}-\d{2})[T ](\d{2}:\d{2})(?::\d{2})?/
  );
  return m ? `${m[1]} ${m[2]}` : String(value);
}

export function candidateDriverName(item) {
  return (
    (item.driver && (item.driver.full_name || item.driver.name)) ||
    item.driver_name ||
    item.driver_id ||
    "-"
  );
}
